<template>
  <div>身份证反面</div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
div {
  font-size: 20px;
}
</style>
